
import { PuttSituation } from "@/types/golf";

export const slopePutts: PuttSituation = {
  id: 3,
  name: "Putts en pente",
  image: "/lovable-uploads/a9ae894f-5663-4cfd-b541-591e4155c24e.png?width=800",
  description: "Sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ de 5 situations de jeu : A=4m, B=6m, C=8m, D=10m, E=12mm.\nPositionner 2 balles par points A, B, C, D, E jouer successivement une balle par situation",
  distances: [
    { point: "A", distance: 4, ballCount: 2 },
    { point: "B", distance: 6, ballCount: 2 },
    { point: "C", distance: 8, ballCount: 2 },
    { point: "D", distance: 10, ballCount: 2 },
    { point: "E", distance: 12, ballCount: 2 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 2 },
    { condition: "Balle à moins de 1m", points: 1 },
    { condition: "Balle au-delà de 1m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 39 },
    { points: 1, index: 33 },
    { points: 2, index: 27 },
    { points: 3, index: 21 },
    { points: 4, index: 16 },
    { points: 5, index: 12 },
    { points: 6, index: 9 },
    { points: 7, index: 6 },
    { points: 8, index: 4 },
    { points: 9, index: 2 },
    { points: 10, index: 0 },
    { points: 11, index: -2 },
    { points: 12, index: -3 },
    { points: 13, index: -4 },
    { points: 14, index: -5 },
    { points: 15, index: -6 },
    { points: 16, index: -7 },
    { points: 17, index: -8 },
  ],
};
